import React, { useState, useRef, useCallback, useEffect } from 'react';
import './assignoffice.scss';
import Modal from '../../components/Modal/Modal';
import { ReactComponent as CloseIcon } from '../../images/Close.svg';
import Input from '../../components/Input/Input';
import Button from '../../components/Button/Button';
import Checkbox from '../../components/Checkbox/Checkbox';
import AgentCard from '../../components/AgentCard/AgentCard';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import avatar from '../../images/avatarDefault.svg';
import base from '../../apis';
import Spinner from '../../components/Spinner/Spinner';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

function AssignOffice() {
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [assignedMembers, setAssignedMembers] = useState([]);
  const [unAssignedMembers, setUnAssignedMembers] = useState([]);
  const [offices, setOffices] = useState([]);
  const OFFICES = useRef([]);
  const OFFICES_POOL = useRef([]);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [officesToAssignTo, setOfficesToAssignTo] = useState([]);
  const [searchParams, setSearchParams] = useState({
    name: '',
    city: '',
    state: '',
    address: '',
  });

  const onChangeSearchParams = (e) => {
    const { name, value } = e.target;
    setSearchParams((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const closeAllModals = () => {
    setModalOpen(false);
    setConfirmModalOpen(false);
  };

  const snr_marketer_id = useSelector((state) => state.auth.marketerDetails.id);

  const getTeamDetails = useCallback(() => {
    setIsLoading(true);
    //todo get snr marketer id from details
    base
      .get(`/operations/snr_marketers/${snr_marketer_id}/team/`)
      .then(({ data }) => {
        if (data.length === 0) {
          toast.warn('You have not been assigned to a team yet. See Administrator for more details.');
          return;
        } else {
          const { members, offices } = data[0];
          if (members.length === 0) toast.warn('No marketing executives have been assigned to your team.');
          if (offices.length === 0) toast.warn('No offices have been assigned to your team.');
          setOffices(offices);
          OFFICES_POOL.current = offices;
          setAssignedMembers(members.filter((member) => member.offices.length));
          setUnAssignedMembers(members.filter((member) => !member.offices.length));
        }
      })
      .catch(() => {
        toast.error('Could not get Details');
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [snr_marketer_id]);

  useEffect(() => {
    getTeamDetails();
  }, [getTeamDetails]);

  const onSelectAgent = (agent) => {
    setModalOpen(true);
    setSelectedAgent(agent);
    OFFICES.current = OFFICES_POOL.current.filter(({ marketer_id }) => !marketer_id || agent.id === marketer_id);
    const officesAssigned = OFFICES_POOL.current
      .filter((office) => office.marketer_id === agent.id)
      .map((office) => office.id);
    setOfficesToAssignTo(officesAssigned);
    setOffices(OFFICES.current);
    if (OFFICES.current.length === 0) {
      toast.warn('No offices to assign to this agent');
    }
  };

  const onToggleChecked = (id) => {
    if (officesToAssignTo.includes(id)) {
      setOfficesToAssignTo(officesToAssignTo.filter((office) => office !== id));
    } else {
      setOfficesToAssignTo([...officesToAssignTo, id]);
    }
  };

  const onSearchSubmit = (e) => {
    e.preventDefault();
    const { name, city, state, address } = searchParams;
    if (!name && !city && !state && !address) {
      setOffices(OFFICES.current);
      return;
    }

    const filteredOffices = OFFICES.current.filter((office) => {
      if (name && !office.branch?.toLowerCase().includes(name?.toLowerCase())) {
        return false;
      }
      if (city && !office.city?.toLowerCase().includes(city?.toLowerCase())) {
        return false;
      }
      if (address && !office.address?.toLowerCase().includes(address?.toLowerCase())) {
        return false;
      }
      if (state && !office.state?.toLowerCase().includes(state?.toLowerCase())) {
        return false;
      }
      return true;
    });

    setOffices(filteredOffices);
  };

  const assignOfficeToMember = () => {
    const { id } = selectedAgent;
    const officestoassign = OFFICES.current
      .filter((office) => officesToAssignTo.includes(office.id))
      .map((item) => ({ id: item.id }));
    const body = { offices: officestoassign };
    const url = `/operations/marketers/${id}/`;
    setIsLoading(true);
    base
      .patch(url, body)
      .then(({ data }) => {
        closeAllModals();
        getTeamDetails();
        toast.success('Assignmnt successful');
      })
      .catch(() => {
        toast.error('Could not assign/unassign office');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onSaveOffices = () => {
    //! check to see if new offices have been added if not prompt user
    const agentOffices = OFFICES.current
      .filter((office) => office.marketer_id === selectedAgent.id)
      .map((office) => office.id);
    const equal = officesToAssignTo.every((item) => agentOffices.includes(item));
    if (equal) {
      toast.warn('Please select an office to assign');
      return;
    }

    if (officesToAssignTo.length > 0) {
      setConfirmModalOpen(true);
    }
  };

  return (
    <>
      {isLoading && <Spinner />}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)} style={{ minWidth: '80%' }}>
        <div className="aomodal">
          <div className="modheader">
            <p>
              <span>Assign to:</span>
              <img
                src={avatar}
                alt="user"
                className="avatar-user"
                style={{
                  width: '50px',
                  height: '50px',
                  marginLeft: '10px',
                  marginRight: '10px',
                }}
              />
              <span>{selectedAgent?.user.first_name + ' ' + selectedAgent?.user.last_name}</span>
            </p>
            <CloseIcon onClick={() => setModalOpen(false)} style={{ fill: 'white', cursor: 'pointer' }} />
          </div>
          <div className="modcontent">
            <form className="modinputs" onSubmit={onSearchSubmit}>
              <Input
                placeholder="Enter Office Name"
                type="search"
                value={searchParams.name}
                name="name"
                onChange={onChangeSearchParams}
                style={{ fontSize: '18px', padding: '10px 20px' }}
              />
              <Input
                placeholder="Enter City"
                type="search"
                name="city"
                onChange={onChangeSearchParams}
                value={searchParams.city}
                style={{ fontSize: '18px', padding: '10px 20px' }}
              />
              <Input
                placeholder="Enter State"
                type="search"
                name="state"
                onChange={onChangeSearchParams}
                value={searchParams.state}
                style={{ fontSize: '18px', padding: '10px 20px' }}
              />
              <Input
                placeholder="Enter Office Address"
                type="search"
                name="address"
                onChange={onChangeSearchParams}
                value={searchParams.address}
                style={{ fontSize: '18px', padding: '10px 20px' }}
              />
              <Button
                style={{
                  width: '100px',
                  fontSize: '18px',
                  padding: '10px',
                  color: 'white',
                  backgroundColor: 'var(--primary-color)',
                  display: 'block',
                }}
                type="submit"
                text="Filter"
                // onClick={}
              />
            </form>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <p>Office List ({offices.length}):</p>
              <p style={{ margin: 'unset', fontSize: '14px', display: 'flex', gap: '20px' }}>
                <span style={{ color: 'var(--primary-color)' }}>Unassigned</span>
                <span style={{ color: 'green' }}>Assigned</span>
              </p>
            </div>
            <div className="ofrow">
              {offices.length > 0 ? (
                offices.map((office) => (
                  <OfficeRow
                    key={office.id}
                    name={office.branch}
                    address={office.address}
                    city={office.city}
                    state={office.state.toUpperCase()}
                    checked={officesToAssignTo.includes(office.id)}
                    toggleChecked={() => onToggleChecked(office.id)}
                    disabled={office?.marketer_id === selectedAgent?.id}
                  />
                ))
              ) : (
                <p style={{ fontWeight: '700', margin: 0 }}>No Unassigned Offices</p>
              )}
            </div>
            <Button
              style={{
                margin: '14px 10px 0 auto',
                width: '100px',
                fontSize: '18px',
                padding: '10px',
                background: 'white',
                color: 'var(--primary-color)',
                display: 'block',
              }}
              text="Save"
              onClick={onSaveOffices}
            />
          </div>
        </div>
      </Modal>

      <ConfirmationModal
        onCancel={() => setConfirmModalOpen(false)}
        onConfirm={assignOfficeToMember}
        open={confirmModalOpen}
        text={`You are assigning ${officesToAssignTo.length} ${
          officesToAssignTo.length > 1 ? 'offices' : 'office'
        }  to ${selectedAgent?.user.first_name + ' ' + selectedAgent?.user.last_name}.`}
      />
      <div className="ao">
        <p className="aoheader">Assign Office</p>
        <div className="aocontainer">
          <p className="aotitle">Ready:</p>
          <div className="aoholder">
            {unAssignedMembers.length > 0 ? (
              unAssignedMembers.map((member) => (
                <AgentCard
                  key={member.id}
                  name={`${member?.user.first_name} ${member?.user.last_name}`}
                  onClick={() => onSelectAgent(member)}
                />
              ))
            ) : (
              <p>No Agents Ready</p>
            )}
          </div>
        </div>
        <div className="aocontainer">
          <p className="aotitle">Busy:</p>
          <div className="aoholder">
            {assignedMembers.length > 0 ? (
              assignedMembers.map((member) => (
                <AgentCard
                  key={member.id}
                  name={`${member?.user.first_name} ${member?.user.last_name}`}
                  onClick={() => onSelectAgent(member)}
                />
              ))
            ) : (
              <p>No Agent Busy</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default AssignOffice;

function OfficeRow({
  name = 'Bankwell Office',
  address = 'Office Address',
  city = 'City',
  state = 'CA',
  onClick,
  checked,
  toggleChecked,
  disabled,
}) {
  return (
    <div className="checker" style={{ borderColor: disabled ? 'green' : '' }}>
      <Checkbox checked={checked} setChecked={toggleChecked} disabled={disabled} />
      <span className="cname" onClick={onClick}>
        {name}
      </span>
      <span className="coffice" onClick={onClick}>
        {address}
      </span>
      <span className="ccity" onClick={onClick}>
        {city}
      </span>
      {state && (
        <span className="cstate" onClick={onClick}>
          {state}
        </span>
      )}
    </div>
  );
}
